import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { getFacebookLocale } from '@change-corgi/config/facebook';

import { usePetitionDetails } from '../../hooks/petitionDetails';

export const MetaLocaleContainer: React.FC = () => {
	const petition = usePetitionDetails();

	return (
		<Helmet>
			<meta
				property="og:locale"
				content={getFacebookLocale(petition.originalLocale.localeCode) || getFacebookLocale('en-US')}
			/>
		</Helmet>
	);
};
